/*
 * @Description : 全局loading
 * @Author      : pishengjun
 * @Date        : 2025-06-12 11:24:30
 */
import { store } from "@/store";

export class Loading {
  static show() {
    store.commit("SHOW_LOADING");
  }

  static hide() {
    store.commit("HIDE_LOADING");
  }
}
